







import Vue from 'vue';
import Splitpanes from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';

export default Vue.extend({
  props: {
    horizontal: Boolean,
    reverse: Boolean
  },
  components: {
    Splitpanes
  }
});
